export const focusOnFirstError = (form: HTMLFormElement) => {
	for (const element of form.elements) {
		const formControlElement = <HtmlFormControlElement>element
		if (!formControlElement.checkValidity()) {
			formControlElement.focus()
			break
		}
	}
}
